<template>
    <div ref="createFrs" class="modal fade" id="confirm_frs_modal" tabindex="-1" role="dialog"
        aria-labelledby="createFrsLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between">
                    <h4 class="">Create FRS</h4>
                    <div class="modal-header border-0 m-0 justify-content-end">
                        <button class="btn-close" id="close-frs-btn" data-bs-dismiss="modal" aria-label="Close"
                            @click="cancelFRS">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                </div>
                <Form @submit="confirm_change" :validation-schema="schema">
                    <div class="modal-body confirm">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-wrap">
                                        <label class="col-form-label d-flex w-100">CED <span
                                                class="text-danger">*</span> </label>
                                        <div class="icon-form">
                                            <Field name="contract_end_date" v-model="formData.contract_end_date"
                                                v-slot="{ field }">
                                                <date-time-picker
                                                    v-model="formData.contract_end_date"
                                                    text-input
                                                    format="dd/MM/yyyy"
                                                    auto-apply
                                                    :enable-time-picker="false"
                                                    :disabled=false
                                                    :clearable=true
                                                />
                                            </Field>
                                            <ErrorMessage name="contract_end_date" class="text-danger" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-wrap">
                                <label class="col-form-label">
                                    Current Supplier
                                    <span class="text-danger">*</span>
                                </label>
                                <Field name="supplier_id" v-model="formData.supplier_id">
                                    <vue-select v-bind="field" :options="supplierOptions" v-model="formData.supplier_id"
                                        placeholder="Select....." @select="myChangeEvent($event)" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"/>
                                </Field>
                                <ErrorMessage name="supplier_id" class="text-danger" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-wrap">
                            <label class="col-form-label">Comment </label>
                            <textarea class="form-control" rows="4" v-model="formData.comment"></textarea>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button type="submit" class="btn btn-primary confirm-btn me-2">
                            Confirm
                        </button>
                        <button type="button" class="btn btn-outline-secondary cancel-btn" @click="cancelFRS">
                            Cancel
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, toRefs } from 'vue';
import { Form, ErrorMessage, Field } from 'vee-validate';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { changeFormate } from '@/util';
import * as Yup from "yup";

export default {
    components: { Form, Field, ErrorMessage },
    props: {
        formData: {
            type: Object,
            default: false
        },
        supplierOptions: {
            type: Object,
            default: false
        },
        oppData: {
            type: Object,
            default: false
        },
    },
    emits: ['created'],
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        // Ensure formData is reactive
        const { formData, supplierOptions, oppData } = toRefs(props);
        const createFrs = ref();

        const schema = Yup.object().shape({
            supplier_id: Yup.string()
                .required("Current Supplier is required"),
            contract_end_date: Yup.string()
                .required("CED  is required"),
        });

        const confirm_change = async () => {
            const data = {
                contract_end_date: changeFormate(formData.value.contract_end_date),
                supplier_id: formData.value.supplier_id,
                comment: formData.value.comment
            }
            const form = {
                oppId: formData.value.id,
                payload: data
            }
            const response = await store.dispatch("opportunity/frsOpportunity", form);
            if (response?.status) {
                document.getElementById("close-frs-btn").click();
                emit('created', response?.data);
                // router.replace({
                //     path: "/crm/meter-opportunities-edit",
                //     query: {
                //         ...router.currentRoute.value.query, // Keep existing query params
                //         opp_Id: response.data.opportunity_id, // Update only opp_Id
                //     },
                // });
                const url = router.resolve({
                    path: `/crm/meter-opportunities-edit/${response?.data?.opportunity_id}`
                }).href;

                window.open(url, "_blank");
            }
        };

        const cancelFRS = async () => {
            formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
            formData.value.supplier_id = oppData.value.supplier_id;
            formData.value.comment = oppData.value.comment;
            formData.value.opp_type = oppData.value.opp_type;
            document.getElementById("close-frs-btn").click();
        };

        const myChangeEvent = (event) => {
            if (event.id === 'null') {
                // supplier_id.value = null;
                formData.value.supplier_id = null;

            }
            else {
                // supplier_id.value = formData.value.supplier_id;
            }
        }

        const clickOutside = () => {
            formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
            formData.value.supplier_id = oppData.value.supplier_id;
            formData.value.comment = oppData.value.comment;
            formData.value.opp_type = oppData.value.opp_type;
        };

        onMounted(() => {
            if (createFrs.value) {
                createFrs.value.addEventListener("hidden.bs.modal", clickOutside);
            }
        });

        return {
            formData,
            supplierOptions,
            confirm_change,
            cancelFRS,
            myChangeEvent,
            schema,
            createFrs
        };
    }
};
</script>
